export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11385.1e470984.jpg";